import { Component } from "@angular/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  footerLinks = {
    aboutUs: [
      { label: "About us", link: "/about" },
      { label: "Blog", link: "/blog" },
      { label: "Data Security", link: "/security" },
      { label: "Careers", link: "/careers" },
      { label: "Science & Technology", link: "/science" },
    ],
    information: [
      { label: "Terms and Conditions", link: "/terms" },
      { label: "Privacy Policy", link: "/privacy" },
      { label: "Refund Policy", link: "/refund" },
      { label: "Customer Support", link: "/support" },
    ],
    products: [
      { label: "DNA tests", link: "/tests/dna" },
      { label: "Blood tests", link: "/tests/blood" },
      { label: "Sleep and Stress", link: "/tests/sleep" },
      { label: "Value packs", link: "/tests/packs" },
      { label: "Gift card", link: "/gift-card" },
    ],
    contact: [
      { label: "info@maxumo.com", link: "mailto:info@maxumo.com" },
      { label: "Contacts", link: "/contact" },
      { label: "Instagram", link: "https://instagram.com" },
      { label: "Youtube", link: "https://youtube.com" },
      { label: "Facebook", link: "https://facebook.com" },
    ],
  };
}
